import React, { useState } from 'react';
import './LoginPage.css';

export default function LoginPage({ onLogin }: { onLogin: (email: string) => void }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    if (!emailRegex.test(email.trim())) {
      setError('Please enter a valid email address.');
      return;
    }

    console.log('[Login] User logged in with email:', email.trim());
    onLogin(email.trim());
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* ChargeHub Logo */}
        <div className="login-logo">
          <div className="login-logo-icon">
            <img
              src="https://chargehub.com/hubfs/B2C/General%20Homepage/Optimized%20HP%20Images/New%20images/ChargeHub%20Logo%20Plug%20Icon%20-%20Clearspace_5.webp"
              alt="ChargeHub"
              width={32}
              height={32}
            />
          </div>
          <span className="login-logo-text">
            <span className="login-logo-charge">Charge</span>
            <span className="login-logo-hub">Hub</span>
          </span>
        </div>

        <h2 className="login-title">Welcome back</h2>
        <p className="login-subtitle">Sign in to access your EV trip plans and chat history</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label className="login-label">Email address</label>
            <input
              type="email"
              className={`login-input ${error ? 'input-error' : ''}`}
              placeholder="you@example.com"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              autoFocus
            />
            {error && <span className="login-error">{error}</span>}
          </div>

          <button type="submit" className="login-btn">
            Continue
          </button>
        </form>

        <p className="login-footer">
          By continuing, you agree to ChargeHub's Terms of Service
        </p>
      </div>
    </div>
  );
}
